import i18n from 'i18next';

// 通知方式 (lineNotify 已在 20250331 停用 Ref: https://app.clickup.com/t/86erptjrj)
export const NOTIFY_DELIVER_TYPE_MAP = {
    EMAIL: 'messageBirdEmail',
    LINE: 'lineNotify'
};

// select list 的標題
export const NOTIFY_TITLE_MAP = {
    EMAIL: i18n.t('Email'),
    LINE: i18n.t('LINE Notify')
};

/**
 * 後端紀錄 Email 通知的類型，是什麼樣的 Email
 * 1: 來自後台的 email (notify 用不到)
 * 2: user 參加活動登入後的 email (notify 預設用此當成 default notify mail => by sponsor)
 * 3: user 參加活動後填表填寫的 email (若有 form email，notify 直接用 form email 取代 login email => by promo)
 * 2: user 手動編輯的 email (所以經 user 手動編輯的 email，notify 直接套用此 email，它的權限最大)
 */
export const NOTIFY_SOURCE_TYPE_MAP = {
    ADMIN_SETTING: 1,
    LOGIN_EMAIL: 2,
    FORM_EMAIL: 3,
    MANUAL_INPUT: 4
};

/**
 * 0: 通知關閉中
 * 1: 通知開啟中
 * 2: 通知授權已過期 (只有在 line notify 會遇到)
 */
export const NOTIFY_STATUS_TYPE_MAP = {
    INACTIVE: 0,
    ACTIVE: 1,
    EXPIRED: 2
};

/**
 * 0: 設定訂閱通知 Dialog
 * 1: 編輯Email通知的 Dialog
 * 2: 確認關閉通知 Dialog
 */
export const NOTIFY_STEP_TYPE_MAP = {
    SET_NOTIFY: 0,
    EDIT_EMAIL: 1,
    CLOSE_NOTIFY: 2
};
